import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';

interface NumberProps {
  unit?: string | null;
  value: ReactNode;
  className?: string;
}

export const Number = ({ value, unit, className }: NumberProps) => (
  <div className={cn('flex items-center justify-end text-base whitespace-nowrap', className)}>
    <span>{value}</span>
    {unit ? <span className="ml-1 text-sm text-tertiary">{unit}</span> : null}
  </div>
);
